import React from 'react';
import CallToAction from '../../../components/calltoaction';
import Testimonies from '../../accueil/testimonies';
import PricingPlans from '../../../components/princingplans/princingplan';
import FonctionsPrincipales from '../../../components/FonctionsPrincipales/FonctionsPrincipales';

const ServiceEmail = () => {
  const features = [
    { id: 1, title: "IMAP", description: "Le protocole IMAP (Internet Message Access Protocol) vous offre un accès à vos e-mails à tout moment, où que vous soyez, et depuis n’importe quel appareil. Vos messages sont conservés sur des serveurs situés dans des data centers ultra sécurisés et restent constamment synchronisés en temps réel pour une mise à jour instantanée.",image: "/assets/images/services/imap.png" },
    { id: 2, title: "Sans publicité", description: "À la différence des services gratuits, les boîtes email IONOS sont entièrement dépourvues de publicités. Cette approche garantit une expérience utilisateur fluide et agréable, vous permettant de lire et rédiger vos messages sans être dérangé par des annonces non sollicitées.", image: "/assets/images/services/sanspub.png" },
    { id: 3, title: "Transfert d'e-mails", description: "Grâce à la fonctionnalité de transfert d'e-mails, vos messages entrants peuvent être automatiquement redirigés vers une autre adresse existante, y compris chez un fournisseur tiers, sans nécessiter de connexion à vos boîtes de réception V_CAM. Vous pouvez modifier ou désactiver cette redirection à tout moment.",image: "/assets/images/services/transfert.png" },
    { id: 4, title: "Anti-spam et protection antivirus", description: "Nos filtres anti-spam avancés assurent une protection efficace de vos boîtes email contre les messages indésirables. Selon le pack sélectionné, une protection antivirus renforcée est également disponible pour sécuriser davantage vos échanges. Hébergées sur nos serveurs hautement sécurisés, vos données bénéficient d’une protection optimale contre les accès non autorisés et les éventuelles défaillances." , image: "/assets/images/services/antivirus.png"},
    { id: 6, title: "Archivage d’emails", description: "La fonctionnalité d’archivage d’e-mails vous offre la possibilité de conserver en toute sécurité vos messages et pièces jointes dans des data centers certifiés situés en Europe. Vous pouvez les restaurer à tout moment, que ce soit pour des besoins juridiques ou pour d'autres raisons.", image: "/assets/images/services/archivage.png" },
    { id: 5, title: "Adresse email basée sur votre domaine", description: "Que ce soit pour un usage personnel ou professionnel, disposer d'une adresse e-mail personnalisée associée à votre propre nom de domaine est un choix judicieux. Les adresses personnalisées reflètent davantage de sérieux et renforcent la confiance de vos interlocuteurs. C’est pourquoi les packs Email V_CAM incluent un domaine pour vous permettre de créer une adresse à votre image." , image: "/assets/images/services/adresse.png"},
  ];
  const plansData = [
    {
      id: 1,
      title: 'SINGLE',
      emails: '30.000XAF/Installation et Configuration (à vie)',
      price: 1000,
      features: [
        '1 personne',
        '1Go de stockage',
        'Prise en main',
        'Calendrier et contacts',
        'Protection anti-virus',
        'Protection antivole',
        'Filtres Anti-spam avancés',
        'Sauvegarde et Restauration d’emails',
      ],
    },
    {
      id: 2,
      title: 'TEAM',
      emails: '30.000XAF/Installation et Configuration (à vie)',
      price: 5000,
      discount: true,
      features: [
        '2-10 Utilisateurs',
        '800Mo de stockage/Bte mail',
        'Prise en main',
        'Calendrier et contacts',
        'Protection anti-virus',
        'Protection antivole',
        'Filtres Anti-spam avancés',
        'Sauvegarde et Restauration d’emails',
      ],
    },
    {
      id: 3,
      title: 'BIG TEAM',
      emails: '50.000XAF/Installation et Configuration (à vie)',
      price: 10000,
      discount: true,
      features: [
        '10-30 Utilisateurs',
        '800Mo de stockage/Bte mail',
        'Prise en main',
        'Calendrier et contacts',
        'Protection anti-virus',
        'Protection antivole',
        'Filtres Anti-spam avancés',
        'Sauvegarde et Restauration d’emails',
      ],
    },
    {
      id: 4,
      title: 'LA TOTALE',
      emails: '50.000XAF/Installation et Configuration (à vie)',
      price: 20000,
      features: [
        '30-50 Utilisateurs',
        '800Mo de stockage/Bte mail',
        'Prise en main',
        'Calendrier et contacts',
        'Protection anti-virus',
        'Protection antivole',
        'Filtres Anti-spam avancés',
        'Sauvegarde et Restauration d’emails',
      ],
    },
  ];

  return (
    <div >
      <>
        <div className='container-fluid header-service-email'>
          <img alt='' src='/assets/images/services/TextInfo.png' className='textinfo' /><br />
          <img alt='' src='/assets/images/services/Frame91.png' className='frame91' />
          <div className='row'>
            <div className='col-6'><h1>500XAF/mois</h1></div>
          </div>
          <a className='voirpacks text-success' href='/solutions/MailPro#voirpacks'>Voir les packs ↗</a>
        </div>
      </>
      <div className='about'>
        <div className='row mb-5'>
          <div className='col-md-6'>
            <h1 className="green">Pourquoi choisir V_Cam pour vos emails?</h1>
            <h3>Adresse email basée sur votre domaine</h3>
            <p className='text-muted text-justify'>Nos solutions e-mail vous offrent la liberté de créer une adresse personnalisée sans être limité à une sélection restreinte, comme c’est le cas avec les services gratuits. De plus, nous incluons un nom de domaine pour toute la durée du contrat, vous permettant d’avoir une adresse unique et adaptée à votre activité professionnelle.
              <br /><br />
              Une adresse e-mail associée au nom de votre entreprise renforce la crédibilité de votre marque et facilite la reconnaissance auprès de vos clients. Vous pouvez également configurer plusieurs adresses dédiées à différents besoins, comme contact@votreentreprise.com ou ventes@votreentreprise.com.
            </p>
          </div>
          <div className='col-md-6'>
            <img src='/assets/images/services/Rectangle221.png' alt='' className='rectangle22' />
            <img src='/assets/images/services/Rectangle231.png' alt='' className='rectangle23' />
          </div>
        </div>
        <div className='row mt-3'>
          <div className='col-md-6 text-center'><img src='/assets/images/services/frame1.png' alt='' width={400} className='frame' /></div>
          <div className='col-md-6 mt-5 '>
            <h3>Adresse email basée sur votre domaine</h3>
            <p className='text-muted text-justify'>Avec V_CAM, votre messagerie est parfaitement sécurisée ! Un filtre anti-spam avancé et une protection antivirus de pointe protègent votre boîte email contre les menaces en ligne. Hébergés sur des serveurs conformes aux normes les plus strictes en matière de protection des données, vos emails bénéficient également d’un chiffrement automatique SSL/TLS pour garantir leur confidentialité. Et si vous effacez accidentellement des messages, pas de panique : notre service de récupération vous permet de restaurer votre messagerie jusqu’à 7 jours après la suppression.
            </p>
          </div>
        </div>
      </div>
      <FonctionsPrincipales features={features} />
      <p id="voirpacks"></p>
      <PricingPlans plansData={plansData} />
      <Testimonies />
      <CallToAction title_secondary="Créer une adresse mail<br/> professionnelle" title_tertiary="Simple, facile et rapide.<br/>Créez votre adresse mail professionnelle dès maintenant." />
    </div>
  );
};

export default ServiceEmail;
